<dx-popup
  title="Détail des statistiques EGAlim"
  [visible]="isDisplayed"
  (onHiding)="closePopup()"
  width="90%"
  height="90%"
  [resizeEnabled]="true">

  <div id="container">
    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label">
          <span>Point de télédéclaration</span>
        </div>
        <div class="value">
          <yo-text-box
            [value]="statistique?.pointTeledeclaration?.libelle"
            readonly="true">
          </yo-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">
          <span>Siret</span>
        </div>
        <div class="value">
          <yo-text-box
            [value]="statistique?.pointTeledeclaration?.siret"
            readonly="true">
          </yo-text-box>
        </div>
      </div>
    </div>

    <div class="dialog-line">
      <div class="dialog-line">
        <div class="label">
          <span>Année</span>
        </div>
        <div class="value">
          <yo-text-box
            [value]="statistique?.annee?.toString()"
            readonly="true">
          </yo-text-box>
        </div>
      </div>
      <div class="dialog-line">
        <div class="label">
          <span>Date de génération</span>
        </div>
        <div class="value">
          <yo-text-box
            [value]="getDateGeneration()"
            readonly="true">
          </yo-text-box>
        </div>
      </div>
    </div>

    <table>
      <thead>
      <tr id="appellations-container">
        <th></th>
        <th *ngFor="let appellation of columns"
            [class.appellation]="appellation != undefined">
          <div>
            {{ appellation ? i8nSvc.getLabelFromCode(appellation) : '' }}
          </div>
        </th>
      </tr>
      <tr id="groups-container">
        <th colspan="2"></th>
        <th colSpan="2" class="color-siqo b-top b-left b-right">SIQO</th>
        <th class="space"></th>
        <th colSpan="5" class="color-autre b-top b-left b-right">Autres EGAlim</th>
        <th class="space"></th>
        <th colspan="2" class="color-critere b-top b-left b-right">Critères d'achat</th>
        <th colspan="4"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let famille of rows; index as index"
          [class.odd]="index % 2 != 0">
        <td>{{ i8nSvc.getLabelFromCode(famille) }}</td>
        <td *ngFor="let appellation of columns"
            class="value"
            [class.color-siqo]="isSiqo(appellation)"
            [class.color-autre]="isAutre(appellation)"
            [class.color-critere]="isCritere(appellation)"
            [class.b-left]="needLeftBorder(appellation)"
            [class.b-right]="needRightBorder(appellation)">
          {{ displayValue(getStatistic(famille, appellation)) }}
        </td>
      </tr>
      <tr id="total">
        <td>TOTAL</td>
        <td *ngFor="let appellation of columns"
            class="value b-bottom"
            [class.color-siqo]="isSiqo(appellation)"
            [class.color-autre]="isAutre(appellation)"
            [class.color-critere]="isCritere(appellation)"
            [class.b-left]="needLeftBorder(appellation)"
            [class.b-right]="needRightBorder(appellation)">
          {{ displayValue(getTotal(appellation)) }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</dx-popup>
